<template lang="pug">
.Menu(:class="{active: s> 100}")
  router-link.MenuItem(
    v-for="item in menuData"
    :key="item.id"
    :to="item.url" :class="{active: s> 100, select: now_path_word() == menu_path_word(item.url)}"
    ) {{ item.name }}
    .second_block(v-if="item.sub")
      router-link(v-for="item2 in item.sub" :key="item2.name" :to="item2.url")
        .item {{ item2.name }}
</template>

<script>
export default {
  data() {
    return {
      menuData: [],
      s: '',
      navbarArray: [
        {
          name: '法規與政策',
          url: '/list/1',
        },
        {
          name: '美感計畫',
          url: '/project/4',
        },
        {
          name: '成果專區',
          url: '/section/178/category/122'
        },
        {
          name: '教學資源',
          url: '/teach',
        },
        {
          name: '文化美感輕旅行',
          url: '/activity/school',
        },
        {
          name: '藝拍即合',
          url: '',
          sub: [
            {
                name: '找補助',
                url: '/artedu1872/subsidy'
            },

            {
                name: '體驗課程',
                url: '/artedu1872/class'
            }
          ]
        },
        {
          name: '縣市填報',
          url: '/activity/results',
        },
       /* {
          name: '報名專區',
          url: '',
          sub: [
            // {
            //   name: '一般活動',
            //   url: '/activity/normal'
            // },
            {
              name: '學校活動',
              url: '/activity/school'
            },
            {
              name: '縣市填報',
              url: '/activity/results'
            },
          ]
        },*/
        // {
        //   name: '活動報名',
        //   url: '/activities',
        // },
        // {
        //   name: '美感人才',
        //   navid: 'HR',
        // },
        // {
        //   name: '計畫申請',
        //   navid: 'Apply',
        // },
        {
          name: '網網相連',
          url: '/link/1',
        },
        {
          name: '搜尋',
          url: '/search',
        }
      ],
    }
  },
  created() {
    this.getMenu();
  },
  mounted() {
    window.addEventListener('scroll', this.scroll);
  },
  methods: {
    getMenu() {
      this.menuData = this.navbarArray
    },
    scroll() {
      this.s = window.scrollY || window.pageYOffset || document.documentElement.scrollTop
    },
    //網頁上的路徑字符
    now_path_word() {
      if (this.$route.path.split('/')[1] == 'project') {
        return this.$route.path.split('/')[1]
      } else {
        return this.$route.path.split('/')[1] + this.$route.path.split('/')[2]
      }
    },
    //當前menu path的字符
    menu_path_word(menuItem) {
      if (this.$route.path.split('/')[1] == 'project') {
        return menuItem.split('/')[1]
      } else {
        return menuItem.split('/')[1] + menuItem.split('/')[2]
      }
    }
  },
}
</script>

<style scoped lang="sass">
@import '@/assets/style.sass'

.Menu
  position: relative
  top: 7.5vw
  box-sizing: border-box
  z-index: 100
  +flexrow
  align-items: center
  justify-content: center
  &.active
    right: 49%
    top: 1.1vw
    +smallcom
      right: 45%
  +pad
    display: none
  .MenuItem
    letter-spacing: 2px
    margin-right: 20px
    // margin-right: 15px
    font-size: 20px
    color: #878787
    text-align: center
    padding: 0 0 5px 0
    // padding: 8px 5px 8px 5px
    // border-radius: 5px
    position: relative

    // +bb
    +maxcom
      font-size: 20px
    +lgcom
      font-size: 20px
    +com
      font-size: 14px

    +smallcom
      min-width: 80px
      // font-size: 1.5vw
      // margin-right: 0.55vw
    &.active

      +smallcom
        font-size: 1.4vw
        margin-right: 0.55vw
    &.select
      // background-color: rgba(#333,0.7)
      // color: white
      border-bottom: solid 2px #777

    &:hover
      .second_block
        display: block
    .second_block
      width: 130%
      margin-left: -18%
      margin-top: 5px
      +bb
      border-color: #999
      // top: 5px
      // margin-top: 5px
      position: absolute
      background-color: #fff
      padding: 10px 0
      display: none
      // box-shadow: 2px 2px 6px 1px rgba(#777,0.5)


      .item
        font-size: 20px
        text-align: center
        line-height: 25px
        letter-spacing: 2px
        +com
          font-size: 13px
        &:hover
          background-color: rgba(#999, 0.2)
          // color: #fff
          // border-bottom: solid 2px #777


</style>



// WEBPACK FOOTER //
// src/components/Menu.vue